export const WORDS = [
  'abbot',
  'albus',
  'alice',
  'avery',
  'dobby',
  'ernie',
  'fleur',
  'filch',
  'ginny',
  'goyle',
  'harry',
  'helga',
  'james',
  'katie',
  'lupin',
  'moody',
  'molly',
  'percy',
  'piers',
  'poppy',
  'ronan',
  'rowle',
  'snape',
  'susan',
  'vance',
  'winky',
  'gaunt',
  'grawp',
  'vince',
  'accio',
  'armor',
  'ashes',
  'badge',
  'basin',
  'bells',
  'blaze',
  'blood',
  'broom',
  'cabin',
  'candy',
  'cards',
  'carol',
  'cedar',
  'chain',
  'charm',
  'chess',
  'chime',
  'cloak',
  'clock',
  'coach',
  'crown',
  'curse',
  'diary',
  'dodge',
  'doors',
  'draft',
  'dream',
  'dress',
  'drink',
  'eagle',
  'elder',
  'elves',
  'ember',
  'feast',
  'fires',
  'flame',
  'flask',
  'flint',
  'flood',
  'forge',
  'ghost',
  'giant',
  'glove',
  'gnome',
  'grave',
  'green',
  'guard',
  'haunt',
  'heart',
  'herbs',
  'holly',
  'honey',
  'house',
  'jelly',
  'judge',
  'juice',
  'knife',
  'knock',
  'leaky',
  'learn',
  'leech',
  'loony',
  'magic',
  'manor',
  'march',
  'masks',
  'metal',
  'midst',
  'moors',
  'mould',
  'music',
  'newts',
  'noble',
  'north',
  'oaths',
  'omens',
  'order',
  'ounce',
  'owlet',
  'paint',
  'panes',
  'party',
  'phase',
  'photo',
  'pipes',
  'pixie',
  'plaid',
  'plank',
  'plate',
  'plums',
  'pouch',
  'power',
  'pride',
  'proof',
  'proud',
  'purse',
  'quill',
  'quirk',
  'quote',
  'quick',
  'raven',
  'reads',
  'relic',
  'rhyme',
  'rings',
  'rival',
  'river',
  'robes',
  'remus',
  'rocks',
  'rooms',
  'roots',
  'runes',
  'rusty',
  'scarf',
  'scars',
  'scour',
  'seers',
  'serum',
  'shade',
  'shard',
  'share',
  'shelf',
  'shell',
  'shine',
  'shone',
  'skull',
  'snare',
  'snout',
  'south',
  'speak',
  'spell',
  'spice',
  'spied',
  'spike',
  'sport',
  'sprig',
  'squad',
  'staff',
  'stags',
  'stair',
  'stare',
  'stars',
  'steal',
  'steam',
  'stick',
  'sting',
  'stirs',
  'stole',
  'stone',
  'storm',
  'study',
  'stuff',
  'sugar',
  'sunny',
  'surly',
  'sword',
  'tabby',
  'tails',
  'tales',
  'teach',
  'tears',
  'teeth',
  'thief',
  'thorn',
  'three',
  'throw',
  'times',
  'toast',
  'token',
  'tower',
  'track',
  'trait',
  'trick',
  'troll',
  'trunk',
  'trust',
  'tulip',
  'twigs',
  'twins',
  'under',
  'unfit',
  'unite',
  'upper',
  'vials',
  'vines',
  'visit',
  'vivid',
  'voice',
  'vowed',
  'wands',
  'watch',
  'water',
  'weeds',
  'weird',
  'whelp',
  'white',
  'widow',
  'winds',
  'wings',
  'witch',
  'witty',
  'woods',
  'worry',
  'wound',
  'woven',
  'wrath',
  'wrist',
  'wrote',
  'young',
  'zonko',
  'beech',
  'beast',
  'berry',
  'birth',
  'black',
  'bones',
  'books',
  'brave',
  'bread',
  'brick',
  'brook',
  'brown',
  'brush',
  'cages',
  'choir',
  'claws',
  'court',
  'creak',
  'crook',
  'dance',
  'demon',
  'dread',
  'eerie',
  'entry',
  'fangs',
  'fence',
  'fifth',
  'first',
]
